
import { VenuesOrg } from '../VenuesOrg';

export class VenuesOrgFa extends VenuesOrg {

  constructor(props) {
    super(props, {pageForOrgType: 'FA'})
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/fas/VenuesOrgFa.js